import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import axios from 'axios'
import { useForm } from "react-hook-form";
import { Oval } from 'react-loader-spinner'
import {baseUrl} from '../../constants'
import { appContext } from '../../Context/appProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { settingsContext } from '../../Context/settingsProvider';

export default function Signup() {
  const {setToken} = useContext(appContext)
  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();
  const [signupMethod, setSignupMethod] = useState({method: 'phone', value: '', action: 'signup'})
  const [step, setStep] = useState(1) // 1 phpne/email, 2 - otp, 3 - information
  const navigate = useNavigate()
  const [error, setError] = useState(null)
  const [otp, setOtp] = useState('');
  const [otpChecking, setOtpChecking] = useState(false)
  const isEmail = signupMethod.method == 'email'
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const {t} = useContext(settingsContext)

  const onSubmit = data => {
    return new Promise((resolve, reject) => {
      const path = step == 1 ? '/send-otp' : '/signup'
      setError()
      axios(baseUrl + '/api/common' + path, {
        method: 'post',
        data: step == 1 ? signupMethod : {...data, ...signupMethod, code: otp}
      }).then(response => {
        const data = response.data
        resolve(true)
        if(step == 1){
          if(!data.success) return setError(data.message)
          if(data.allowSignup){
            if(isEmail){
              setStep(3)
            } else setStep(2)
          }
        } else {
          console.log(response.data)
          if(data.success){
            localStorage.setItem('hwtoken', response.data.token)
            setToken(data.token)
            let next = queryParams.get('next')
            console.log(next)
            if(next) window.location.href = next
            else navigate('/')
          } else setError(data.message)
        }
      })
      .catch(e => {
        resolve(true)
        setError('Network Error')
      })
    })
  }

  const changeMethod = (method) => {
    setSignupMethod(s => ({...s, method}))
  }

  const onOtpChange = (value) => {
    setOtp(value)
    if(value.length == 4){
      setOtpChecking(true)
      axios(baseUrl + '/api/common/verify', {
        method: 'post',
        data: {
          code: value,
          identifier: signupMethod.value
        }
      }).then(response => {
        const data = response.data
        if(data.success){
          setStep(3)
          setError()
        } else setError('Invalid Code!')
      }).finally(() => setOtpChecking(false))
    }
  }

  

  return (
    <div className='w-full h-screen flex flex-col pt-[60px] overflow-x-hidden'>
      <Header withLogo />
      <form onSubmit={handleSubmit(onSubmit)} className='flex-1 flex flex-col gap-5 items-center pt-10 pb-10'>
      {error && (
        <p className='bg-[#f946464f] text-[#f94646] text-[15px] font-bold px-10 py-2 rounded-sm'>
          {error}
        </p>
      )}

        {(step == 2 && !error) &&  <p className='bg-[#36af014f] text-[#1a6500] text-[15px] font-bold px-10 py-2 rounded-sm'>OTP Sent!</p>}
        {step == 1 && <div className='rounded-[30px] p-2 bg-[#00000030] shadow-md'>
          <button onClick={() => changeMethod('phone')} className={`rounded-[30px] px-4 py-1 border-none outline-none ${!isEmail ? 'bg-black text-white' : 'bg-none text-black'}`} type='button'>
          {t('PHONE')}
          </button>
          <button onClick={() => changeMethod('email')} className={`rounded-[30px] px-4 py-1 border-none outline-none ${isEmail ? 'bg-black text-white' : 'bg-none text-black'}`} type='button'>
          {t('EMAIL')}
          </button>
        </div> }
        <h3 className='text-black  text-[20px uppercase'> {t('SIGNUP')}</h3>
        {step == 1 ? (
          <input onChange={e => setSignupMethod(s => ({...s, value: e.target.value}))} placeholder={isEmail ?  t('EMAIL') :  t('PHONE') + ' (09xxxxxxxx)'} type={isEmail ? 'email' : 'number'} className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required/>
        ) : step == 2 ? (
          <>
            <OtpInput
              value={otp}
              onChange={onOtpChange}
              numInputs={4}
              inputStyle={'border-[1px] border-black p-3 !w-[40px] rounded-md'}
              renderSeparator={<span style={{marginLeft: 5, marginRight: 5 }}></span>}
              renderInput={(props) => <input style={{border: '1px sold #000000'}} {...props} />}
            />
            <button className='text-sm underline' onClick={() => setStep(1)}>Change Phone Number</button>
          </>
        ) :(
          <>
            <input {...register('firstName')} placeholder= {t('FIRST_NAME')} type='text' className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4'  required/>
            <input {...register('lastName')} placeholder={t('LAST_NAME')} type='text' className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required />
            <input {...register('password')} placeholder={t('PASSWORD')} type='password' className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required />
          </>
        )}
        {step != 2 && <button className='bg-main w-[400px] max-md:w-[300px] text-white text-[20px] rounded-md p-2 flex items-center justify-center' type='submit'>
          {isSubmitting ? (
            <Oval
            visible={true}
            height="30"
            width="30"
            color="#ffffff"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
            strokeWidth={3}
            />
          ) : step == 3 ? 'Complete Signup' :  t('SIGNUP')}
          </button> }
          {otpChecking && (
            <Oval
            visible={true}
            height="30"
            width="30"
            color="#6622cf"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
            strokeWidth={3}
            />
          )}
        <hr className='w-full text-[#00000040]'/>
        <div className='w-full flex items-center justify-center px-6'>
          <Link to='/login' className='text-[13px] text-[#4848ff]'> {t('HAVE_ACCOUNT')}</Link>
        </div>
      </form>
      <Footer />
    </div>
  )
}